export enum ApiKeys {
  UserCurrent = 'api/user/current',
  UserCurrentPendingOrders = 'api/user/current/orders/pending',
  UserCurrentOrders = 'api/user/current/orders',
}

export const LOCALE = 'en-GB'

export const MENU_RECOMMENDED_CATEGORY_UUID = '97270056-cd65-11e8-a2d2-067a72dd5dba'
